module.exports = __webpack_public_path__ + "img/index-logo.3c93651c.png";